import { devURL } from '../../constants';

export async function checkUserEmail(email,token) {
 let headers = new Headers();
  headers.append('Content-Type', 'application/json');
  headers.append('Authorization', `Bearer ${token}`);
  const url = '/ros_be_app_directory/users/checkUserEmailExist/';
  //const url = 'http://localhost:5000/ros_be_app_directory/users/checkUserEmailExist/';

 return await fetch(url + email, {
    method: 'GET',
    headers: headers
  })
    .then(resp => {
      if (!resp.ok) {
        // eslint-disable-next-line no-throw-literal
        throw `Server error: [${resp.status}] [${resp.statusText}] [${resp.url}]`;
      }
      return resp.json();
    })
    .catch(err => {
      console.debug("Error in fetch", err);
    });
}

export async function getFavourtieApps(email, token) {
   
  let headers = new Headers();
  headers.append('Content-Type', 'application/json');
  headers.append('Authorization', `Bearer ${token}`);
  const url = '/ros_be_app_directory/users/getFavouriteApps/';
  //const url = 'http://localhost:5000/ros_be_app_directory/users/getFavouriteApps/';

  return await fetch(url + email, {
    method: 'GET',
    headers: headers
  }).then(response => {
    if (!response.ok) {
       throw `Server error: [${response.status}] [${response.statusText}] [${response.url}]`;
    }
    return response.json();
  }).catch(error => {
    console.debug("Error in fetch", error);
  });

}

export async function setUnsetFavouriteApps(email, appId,favourite,token) {
  let headers = new Headers();
  headers.append('Content-Type', 'application/json');
  headers.append('Authorization', `Bearer ${token}`);

  const url = '/ros_be_app_directory/users/setUnsetFavouriteApps/';
  //const url = 'http://localhost:5000/ros_be_app_directory/users/setUnsetFavouriteApps/';

  return await fetch(url, {
    method: 'POST',
    headers: headers,
    body: JSON.stringify({
      email: email,
      appId: appId,
      favourite: favourite
    })
  }).then(response => {
      if (!response.ok) {
        // eslint-disable-next-line no-throw-literal
        throw `Server error: [${response.status}] [${response.statusText}] [${response.url}]`;
      }
      return response.json();
    }).catch(error => {
      console.debug("Error in fetch", error);
    });
}

export async function checkUserType(email,token) {
  let headers = new Headers();
   headers.append('Content-Type', 'application/json');
   headers.append('Authorization', `Bearer ${token}`);
   const url = '/ros_be_app_directory/users/checkUserType/';
   //const url = 'http://localhost:5000/ros_be_app_directory/users/checkUserType/';
 
  return await fetch(url + email, {
     method: 'GET',
     headers: headers
   })
     .then(resp => {
       if (!resp.ok) {
         // eslint-disable-next-line no-throw-literal
         throw `Server error: [${resp.status}] [${resp.statusText}] [${resp.url}]`;
       }
       return resp.json();
     })
     .catch(err => {
       console.debug("Error in fetch", err);
     });
 }